<template>
<div style="width: 100%;height: auto;padding-bottom: 100px;padding-top: 60px" class="flex flex-column align-center">
  <Breadcrumb :value="[$t('h.tabName1'),$t('h.tabName2'),$t('h.tabName2Item8')]"/>
  <div style="width: 1200px;background: white;border-radius: 4px;padding: 20px;margin-top: 20px;">
<div class="icons-container">
  <div 
    v-for="(item, index) in iconsList" 
    :key="item.id || index"
    class="icons-item"
  >
    <a 
      :href="item.linkAddress" 
      target="_blank"
      rel="noopener noreferrer"
    >
      <img 
        :src="item.coverImage" 
        :alt="`partner-logo-${index}`"
        class="custom-image"
        @error="handleImageError"
      >
    </a>
  </div>
</div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
	      iconsList: [
        // 国内媒体 1
        {
          id: 1,
          coverImage: require('@/assets/img/media/domestic/1高电压技术.jpg'),
          linkAddress: ""
        },
        // 海外媒体 1
        {
          id: 2,
          coverImage: require('@/assets/img/media/overseas/1-Ringier.png'),
          linkAddress: "https://www.ringier.com/"
        },
        // 国内媒体 2
        {
          id: 3,
          coverImage: require('@/assets/img/media/domestic/2金属制品.gif'),
          linkAddress: "https://www.cswpn.com/"
        },
        // 海外媒体 2
        {
          id: 4,
          coverImage: require('@/assets/img/media/overseas/2-Vogel.png'),
          linkAddress: "https://brand.vogel.com.cn/qyjj/"
        },
        // 国内媒体 3
        {
          id: 5,
          coverImage: require('@/assets/img/media/domestic/3绝缘材料.jpg'),
          linkAddress: "https://jyct.cbpt.cnki.net/WKD/WebPublication/index.aspx?mid=jyct"
        },
        // 海外媒体 3
        {
          id: 6,
          coverImage: require('@/assets/img/media/overseas/3-Expo Metals.png'),
          linkAddress: "https://www.expometals.net/en/online-fair"
        },
        // 国内媒体 4
        {
          id: 7,
          coverImage: require('@/assets/img/media/domestic/4光纤与光缆.jpg'),
          linkAddress: ""
        },
        // 海外媒体 4
        {
          id: 8,
          coverImage: require('@/assets/img/media/overseas/4-Wire & Cable Technology International.png'),
          linkAddress: "https://wiretech.com/"
        },
        // 国内媒体 5
        {
          id: 9,
          coverImage: require('@/assets/img/media/domestic/5电气时代.png'),
          linkAddress: ""
        },
        // 海外媒体 5
        {
          id: 10,
          coverImage: require('@/assets/img/media/overseas/5-wire journal.png'),
          linkAddress: "https://wirenet.org/resources/publications/wire-journal-international/"
        },
        // 国内媒体 6
        {
          id: 11,
          coverImage: require('@/assets/img/media/domestic/6电线电缆期刊.png'),
          linkAddress: ""
        },
        // 海外媒体 6
        {
          id: 12,
          coverImage: require('@/assets/img/media/overseas/6-Kablo Tel D眉nyas谋.png'),
          linkAddress: "https://www.kabloteldunyasi.com/"
        },
        // 国内媒体 7
        {
          id: 13,
          coverImage: require('@/assets/img/media/domestic/7上缆所传媒.jpg'),
          linkAddress: ""
        },
        // 海外媒体 7
        {
          id: 14,
          coverImage: require('@/assets/img/media/overseas/7-Kablosan Turkey.png'),
          linkAddress: "https://kablosanturkey.com/"
        },
        // 国内媒体 8
        {
          id: 15,
          coverImage: require('@/assets/img/media/domestic/8电线电缆网.png'),
          linkAddress: "https://www.cwc.net.cn/"
        },
        // 海外媒体 8
        {
          id: 16,
          coverImage: require('@/assets/img/media/overseas/8-World Media Group.png'),
          linkAddress: "https://world-media-group.com/"
        },
        // 国内媒体 9
        {
          id: 17,
          coverImage: require('@/assets/img/media/domestic/9北极星会展网.png'),
          linkAddress: "https://ex.bjx.com.cn/"
        },
        // 海外媒体 9
        {
          id: 18,
          coverImage: require('@/assets/img/media/overseas/9-Industrial Technology Research Institute.png'),
          linkAddress: "https://www.itri.org.tw/english/"
        },
        // 国内媒体 10
        {
          id: 19,
          coverImage: require('@/assets/img/media/domestic/10中国制造网.png'),
          linkAddress: "https://cn.made-in-china.com/ "
        },
        // 海外媒体 10
        {
          id: 20,
          coverImage: require('@/assets/img/media/overseas/10-Insight Machinery Magazine.png'),
          linkAddress: "https://www.phdbooks.com.tw/en/"
        },
        // 国内媒体 11
        {
          id: 21,
          coverImage: require('@/assets/img/media/domestic/12塑料工业.jpg'),
          linkAddress: ""
        },
        // 海外媒体 11
        {
          id: 22,
          coverImage: require('@/assets/img/media/overseas/11-Korea Newswire.png'),
          linkAddress: "https://www.koreanewswire.co.kr/"
        },
        // 国内媒体 12
        {
          id: 23,
          coverImage: require('@/assets/img/media/domestic/13cabex.png'),
          linkAddress: "https://www.cabex.ru/en-GB/"
        },
        // 海外媒体 12
        {
          id: 24,
          coverImage: require('@/assets/img/media/overseas/12-S & M Media Steel & Metal News.png'),
          linkAddress: "http://www.snmnews.com/"
        },
        // 国内媒体 13
        {
          id: 25,
          coverImage: require('@/assets/img/media/domestic/14c114.png'),
          linkAddress: "www.c114.com.cn/expo/"
        },
        // 海外媒体 13
        {
          id: 26,
          coverImage: require('@/assets/img/media/overseas/13-Kinzoku Sangyo Shimbun.png'),
          linkAddress: ""
        },
        // 国内媒体 14
        {
          id: 27,
          coverImage: require('@/assets/img/media/domestic/15东莞源杰.gif'),
          linkAddress: "http://www.cablesnews.com/"
        },
        // 海外媒体 14
        {
          id: 28,
          coverImage: require('@/assets/img/media/overseas/14-Densen Shimbun.jpg'),
          linkAddress: ""
        },
        // 国内媒体 15
        {
          id: 29,
          coverImage: require('@/assets/img/media/domestic/16线缆招聘网.gif'),
          linkAddress: "https://www.cabhr.com"
        },
        // 海外媒体 15
        {
          id: 30,
          coverImage: require('@/assets/img/media/overseas/15-Steel Technology.png'),
          linkAddress: "https://www.steeltechnologies.com/"
        },
        // 国内媒体 16
        {
          id: 31,
          coverImage: require('@/assets/img/media/domestic/17线缆商情.gif'),
          linkAddress: "www.chinaxlw.net"
        },
        // 海外媒体 16
        {
          id: 32,
          coverImage: require('@/assets/img/media/overseas/16-Plant Automation Technology.png'),
          linkAddress: "https://www.plantautomation-technology.com/"
        },
        // 海外媒体 17（剩余的海外媒体）
        {
          id: 33,
          coverImage: require('@/assets/img/media/overseas/17-Trade India.jpg'),
          linkAddress: "https://www.tradeindia.com/"
        },
		{
		  id: 34,
		  coverImage: require('@/assets/img/media/overseas/CRU.jpg'),
		  linkAddress: "https://www.crugroup.com/en/commodities/wire-and-cable/"
		}
      ]
    };
  },
  methods: {  // 正确包裹方法
    getImgPageList() {
      const type = this.showTitle.find(t => t.select).type;
      this.$axios.get(`${displayCompany}?type=${type}`)
        .then(res => {
if (res && res.data && res.data.success) {
  _this.iconsList = res.data.result.filter(function (item) {
    return item.coverImage && item.linkAddress;
  });
}
        })
        .catch(error => {
          console.error('数据获取失败:', error);
        });
    },
    itemClick(index) {
      this.showTitle.forEach(item => { item.select = false; });
      this.showTitle[index].select = true;
      this.getImgPageList();
    },
    handleImageError(event) {  // 新增错误处理方法
      event.target.style.display = 'none';
    }
  }
};
</script>


<style scoped>
/* 容器样式 */
.icons-container {
  width: 1200px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 15px;
  padding: 10px 0;
}

/* 图片项样式 */
.icons-item {
  background: #fff;
  border-radius: 8px;
  height: 108px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
}

.icons-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

/* 图片自适应 */
.custom-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  padding: 8px;
}
</style>
